import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <span>© {new Date().getFullYear()} NexterZone</span>

        <nav className="footer-links" aria-label="Footer">
          <Link to="/trust-safety">Trust & Safety</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/help">Help Center</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/data-deletion">Data Deletion Policy</Link>
          <Link to="/support">Contact Support</Link>
                  
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
